// Shared helpers for cascade response patterns that don't involve the chart of
// accounts. Two patterns kept showing up across the cascade files:
//
//   1. Take the reviewer's chosen response and mark the step completed,
//      labelled with the human-readable description of that response. Used
//      by every "determine_X" cascade and by acknowledgement branches inside
//      "resolve" cascades.
//
//   2. Convert a user-entered amount into an AJE proposal — or, if the amount
//      hasn't been entered yet, prompt for it. Used by every "need_aje" /
//      "recognize_now" / "need_provision" branch.

// Marks the step completed with labels[response] as the detail.
// Always clears prompt (completed steps never render prompts anyway, and this
// keeps the shape consistent).
export function labelResponse(resolved, response, labels) {
	return { ...resolved, status: "completed", detail: labels[response] || response, prompt: null };
}

// "Resolve via amount input then AJE proposal."
//
// If amount is present in userResponses, return a ready_to_propose step with
// the inline AJE (amount filled in from the user's entry). Otherwise, return
// a waiting_for_human step that prompts for the amount.
//
// options.proposal carries every inline_proposal field except amount:
//   { debitCanonicalCode, debitDescription, debitGifi, creditCanonicalCode,
//     creditDescription, creditGifi, description }
// options.inputField is a single input descriptor:
//   { id, label, input_type }
export function proposeAjeFromAmount(resolved, amount, options) {
	if (amount != null && amount !== "") {
		return {
			...resolved, status: "ready_to_propose", detail: null,
			inline_proposal: { amount: Number(amount), ...options.proposal },
		};
	}
	return {
		...resolved, status: "waiting_for_human",
		detail: options.promptDetail,
		prompt: { question: options.promptQuestion, input_fields: [options.inputField] },
	};
}
